var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisibleOn = function SvgVisibleOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24 36.844c-8.302 0-15.848-4.584-19.694-11.96a1.9 1.9 0 0 1 0-1.768C8.152 15.74 15.698 11.156 24 11.156s15.848 4.584 19.694 11.96c.29.554.29 1.214 0 1.768C39.848 32.26 32.302 36.844 24 36.844M8.182 24A18.33 18.33 0 0 0 24 33.023 18.33 18.33 0 0 0 39.818 24 18.33 18.33 0 0 0 24 14.977 18.33 18.33 0 0 0 8.182 24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.003 32.419c-4.573 0-8.292-3.72-8.292-8.287 0-4.571 3.72-8.29 8.292-8.29 4.568 0 8.287 3.719 8.287 8.29 0 4.568-3.719 8.287-8.287 8.287m0-12.757a4.475 4.475 0 0 0-4.472 4.47 4.475 4.475 0 0 0 4.472 4.467 4.47 4.47 0 0 0 4.467-4.468 4.473 4.473 0 0 0-4.467-4.469"
  })));
};
export default SvgVisibleOn;